/* eslint-disable no-restricted-syntax */
import { Board, BoardOrder, BoardParticipant, Partner } from 'types';

import getParticipantInstruction from 'utils/getParticipantInstructions';
import getRepresentedPartnersIds from './getRepresentedPartnersIds';
import createSelectorOption from './createSelectOption';
import getVoteValueInOrder from './getVoteValueInOrder';
import { Represented } from '../types/Represented';
import { getPartner } from './getPartner';

type RepresentedProps = {
  partnerId: string;
  board: Board;
  order: BoardOrder;
  partners: Partner[];
  withInstructions: boolean;
};

type CurrentRepresentedProps = {
  partnerId: string;
  board: Board;
  order: BoardOrder;
  partners: Partner[];
};

const isParticipantIncluded = (
  participant: BoardParticipant,
  representedPartnersIds: string[]
) => representedPartnersIds?.includes(participant?.member);

const isParticipantCurrentType = (
  participant: BoardParticipant,
  withInstructions: boolean
) =>
  withInstructions
    ? participant?.delegationVote?.instructionType
    : !participant?.delegationVote?.instructionType;

const isParticipantRepresented = (
  participant: BoardParticipant,
  representedPartnersIds: string[],
  withInstructions: boolean
) => {
  const includesParticipant = isParticipantIncluded(
    participant,
    representedPartnersIds
  );
  const isCurrentType = isParticipantCurrentType(participant, withInstructions);

  return includesParticipant && isCurrentType;
};

const getParticipantPartner = (
  participant: BoardParticipant,
  partners: Partner[]
) => getPartner(participant?.member, partners);

export const getCurrentRepresented = ({
  partnerId,
  board,
  order,
  partners,
}: CurrentRepresentedProps) => {
  for (const participant of board?.participants) {
    const isCurrentParticipant = participant?.member === partnerId;

    if (isCurrentParticipant) {
      const partner = getParticipantPartner(participant, partners);
      const vote = getVoteValueInOrder(participant, order);
      const instruction = getParticipantInstruction(participant, order);

      if (partner) {
        const option = createSelectorOption(partner, vote, instruction);
        return option;
      }
    }
  }
};

export const getRepresented = ({
  partnerId,
  board,
  order,
  partners,
  withInstructions,
}: RepresentedProps) => {
  const options: Represented[] = [];

  const representedPartnersIds = getRepresentedPartnersIds(board, partnerId);

  board?.participants?.forEach((participant: BoardParticipant) => {
    const isRepresented = isParticipantRepresented(
      participant,
      representedPartnersIds,
      withInstructions
    );

    if (isRepresented) {
      const partner = getParticipantPartner(participant, partners);
      const vote = getVoteValueInOrder(participant, order);
      const instruction = getParticipantInstruction(participant, order);

      if (partner) {
        const option = createSelectorOption(partner, vote, instruction);
        options.push(option);
      }
    }
  });
  return options;
};
